
import { downloadUrl } from 'bits/attachments'
import { Component, namespace, State, Vue } from 'bits/vue'
const share = namespace('share')

@Component({})
class QrModal extends Vue {
  @State((state) => state.constants.iosAppUrl) IOS_APP_URL
  @State((state) => state.constants.androidAppUrl) ANDROID_APP_URL
  @State((state) => state.constants.itunesBadgeUrl) ITUNES_BADGE_URL
  @State((state) => state.constants.playStoreBadgeUrl) PLAY_STORE_BADGE_URL
  @State((state) => state.wall.links.qr_code) qrCodeUrl
  @share.Action closeQrModal

  imgSize = 640

  get downloadUrl(): string {
    return downloadUrl(this.qrCodeUrl)
  }

  mounted() {
    const container: HTMLDivElement = this.$refs.container as HTMLDivElement
    this.imgSize = container.clientWidth
  }
}

export default QrModal
